(ns dre.pages.frontpage.views
  (:require
   [dre.app.events :as-alias app]
   [dre.components.icon :refer [icon]]
   [dre.components.privacy.utils :as privacy]
   [dre.components.tooltip :refer [tooltip-wrapper]]
   [dre.i18n.views :refer [tr]]
   [dre.modals.events :as-alias modals]
   [dre.pages.frontpage.events :as-alias fp]
   [dre.pages.frontpage.keyword-search.views :as keyword-search]
   [dre.pages.frontpage.topic-search.views :as topic-search]
   [dre.page-util :refer [around]]
   [dre.utils :refer [allowed-source?]]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]))

(def component-name :search-type-selection)

(defn- search-type-selection-item
  [{:keys [item-key icon-key title tooltip-text selected-key]}]
  (let [selected? (= item-key selected-key)
        content [:div
                 {:class (bem/bem component-name :item [item-key (when selected? :active)])}
                 [icon :common icon-key]
                 [:a
                  {:href "#"
                   :on-click #(rf/dispatch [::fp/select-search-type item-key])}
                  [:span
                   {:class (bem/be component-name :item-title-normal)}
                   [tr title]]
                  [:span
                   {:class (bem/be component-name :item-title-bold)}
                   [tr title]]]
                 [:div
                  {:class (bem/be component-name :active-indicator)}]]]
    [:li
     {:class (bem/be component-name :item-container)}
     (if selected?
       content
       [tooltip-wrapper
        tooltip-text
        content
        {:placement :bottom
         :overlayStyle {:whiteSpace :noWrap
                        :maxWidth "500px"}}])]))

(defn search-type-selection
  [{selected :search-type}]
  [:ul
   {:class component-name}
   [search-type-selection-item {:item-key :topic-search
                                :icon-key :list
                                :title "Topic Search"
                                :tooltip-text "Click to build a search using predefined topics"
                                :selected-key selected}]
   [:div
    {:class (bem/be component-name :separator)}]
   [search-type-selection-item {:item-key :keyword-search
                                :icon-key :magnifying-glass
                                :title "Search Bar"
                                :tooltip-text "Click to build a search with the search bar"
                                :selected-key selected}]])

(defn stats-info
  [{{stats :data} :stats-info} user]
  (when (and @(rf/subscribe [::fp/show-stats-footer?])
             stats)
    (let [m+ (fn [& more] (apply + (keep identity more)))
          total (m+
                 (when (allowed-source? "feeds:*" user)
                   (:feed-entries-count stats))
                 (when (allowed-source? "medline" user)
                   (:medline-count stats))
                 (when (allowed-source? "clinicaltrials" user)
                   (:clinicaltrials-count stats))
                 (when (allowed-source? "cord19:*" user)
                   (:cord19-count stats))
                 (when (allowed-source? "dailymed" user)
                   (:dailymed-count stats))
                 (when (allowed-source? "epar" user)
                   (:epar-count stats))
                 (when (allowed-source? "pmc" user)
                   (:pmc-count stats))
                 (when (allowed-source? "embase" user)
                   (:embase-count stats))
                 (when (allowed-source? "ccc" user)
                   (:ccc-count stats))
                 (when (allowed-source? "science-direct" user)
                   (:science-direct-count stats))
                 (when (allowed-source? "nih" user)
                   (:nih-count stats))
                 (when (allowed-source? "patent" user)
                   (:patent-count stats))
                 (when (allowed-source? "epar-pdf" user)
                   (:epar-pdf-count stats))
                 (when (allowed-source? "who-ictrp:*" user)
                   (:who-ictrp-count stats))
                 (when (allowed-source? "doc-congress:*" user)
                   (:doc-congress-count stats))
                 (when (allowed-source? "doc-congress-dev:*" user)
                   (:doc-congress-dev-count stats)))]
      [:div.box.stats-info
       [:p
        [:strong [tr "Literature Search is a specialized medical search engine that is built with advanced artificial intelligence technology."]]]
       [:p
        [tr "Our database currently contains %s biomedical citations, %s biomedical relationships and %s medical concepts."
         (around total)
         (around 108000000)
         (around (:label-count stats))]
        [:br]
        [tr "We search PubMed (%s)"
         (around (:medline-count stats))]
        [tr ", PubMed Central (%s)"
         (around (:pmc-count stats))]
        [tr ", ClinicalTrials.gov (%s)"
         (around (:clinicaltrials-count stats))]
        [tr ", COVID-19 Open Research Dataset (%s)"
         (around (:cord19-count stats))]
        [tr ", DailyMed (%s)"
         (around (:dailymed-count stats))]
        [tr ", EPAR (%s)"
         (around (:epar-count stats))]
        [tr ", WHO ICTRP (%s from %s "
         (around (:who-ictrp-count stats))
         (around (:who-ictrp-sources-count stats))]
        [:a {:href "#"
             :on-click #(rf/dispatch [::modals/set-modal :ds-stats :who-ictrp])}
         [tr "sources"]]
        ")"
        [tr ", Patents (%s)"
         (around (:patent-count stats))]
        (when (allowed-source? "doc-congress:*" user)
          [:<> [tr ", Congresses (%s from %s "
                (around (:doc-congress-count stats))
                (around (:doc-congress-sources-count stats))]
           [:a {:href "#"
                :on-click #(rf/dispatch [::modals/set-modal :ds-stats :congresses])}
            [tr "sources"]]
           ")"])
        [tr ", NIH Grants (%s)"
         (around (:nih-count stats))]
        (when (allowed-source? "feeds:*" user)
          [:<>
           [tr ", and RSS feeds (%s from %s "
            (around (:feed-entries-count stats))
            (around (:feed-count stats))]
           [:a {:href "#"
                :on-click #(rf/dispatch [::modals/set-modal :ds-stats :feeds])}
            [tr "feeds"]]
           ")"])
        "."]])))

(defn privacy-notice
  []
  (when @(rf/subscribe [::fp/show-stats-footer?])
    (let []
      [:div.privacy-notice
       [:strong [tr "Dr.Evidence adheres to global security and data privacy guidelines and regulations. For more information, please"] 
        [:a {:href privacy/privacy-pdf-url
             :target "_blank"}
         " " [tr "click"] " "]
        [tr "to review our information management policy. "]]
       ])))

(defn view
  []
  (let [state @(rf/subscribe [::fp/state])
        user @(rf/subscribe [::app/user])]
    [:<>
     [search-type-selection state]

     (case (:search-type state)
       :topic-search
       [:<>
        [topic-search/view]
        [stats-info state user]
        [privacy-notice]]
       :keyword-search
       [:<>
        [keyword-search/view]
        [stats-info state user]
        [privacy-notice]]
       nil)]))
